import { render, staticRenderFns } from "./PostApprove.vue?vue&type=template&id=2ae9c51a"
import script from "./PostApprove.vue?vue&type=script&lang=js"
export * from "./PostApprove.vue?vue&type=script&lang=js"
import style0 from "./PostApprove.vue?vue&type=style&index=0&id=2ae9c51a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports